import { useCustomNavigate } from "core/hooks/useCustomNavigate";
import Image from "../Image";
import { route, RouterName } from "core/router";
import { useUser } from "modules/Auth/hooks";
import NumericTimeAgoWithUnit from "../TimeAgo/NumericTimeAgoWithUnit";

interface CUserProps {
  avatar: string;
  name: string;
  id?: number;
  date?: string;
  disableClick?: boolean;
}
const CUser = ({ avatar, name, id, date, disableClick = false }: CUserProps) => {
  const { userInfo } = useUser();
  const navigate = useCustomNavigate();
  const handleClick = () => {
    if (disableClick) return
    const idPerson = id || userInfo?.id; // if id is not provided, use the user's id
    if (idPerson) {
      navigate(route(RouterName.PERSONAL_CHANNEL, idPerson));
    }
  };

  return (
    <div className="flex items-center w-full" onClick={() => handleClick()}>
      <div className="mr-[6px]">
        <Image
          src={avatar}
          alt={name}
          className="object-cover rounded-full min-w-6 w-6 h-6"
        />
      </div>
      <div className="flex flex-col">
        <h3 className="text-[13px] font-medium text-[#111111] 
        line-clamp-1 overflow-hidden min-w-[100px]
        ">{name}</h3>
        {date && (
          <span className="text-[11px] text-[#777777]">
            <NumericTimeAgoWithUnit
              createdAt={date || ""}
              locale={(window as any)._APP_LANG}
            />
          </span>
        )}
      </div>
    </div>
  );
};

export default CUser;
